import { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M28 8H4v16h24V8Zm-8.368 9.28c0 1.485 1.155 2.64 3.19 2.64s3.08-1.045 3.08-2.365c0-1.32-.66-1.98-2.2-2.255l-1.21-.22c-.715-.132-.935-.33-.935-.715 0-.44.385-.825 1.155-.825.858 0 1.375.506 1.375 1.1h1.76c0-1.54-1.1-2.64-3.135-2.64-1.87 0-2.915 1.045-2.915 2.365 0 1.21.66 1.892 2.035 2.145l1.21.22c.825.154 1.1.44 1.1.825 0 .44-.385.825-1.32.825s-1.43-.495-1.43-1.1h-1.76Zm-9.54.011 2.288 2.519h-2.189l-2.156-2.475H7.76v2.475H6v-7.7h3.641c1.485 0 2.519 1.067 2.519 2.662 0 1.408-.946 2.442-2.068 2.519ZM7.76 13.76v1.98h1.782c.473 0 .858-.407.858-.99s-.385-.99-.858-.99H7.76Zm10.997 6.05h-5.28v-7.7h5.28v1.595h-3.52v1.485h3.3v1.54h-3.3v1.485h3.52v1.595Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
